module.exports = __webpack_public_path__ + "static/media/visa.729c05c2.svg";